import { useMutation } from '@tanstack/vue-query';
import { dscvrIcApi } from '@/shared/api';

export const useDeletePortalRoleMutation = () => {
  return useMutation({
    mutationKey: ['delete-portal-role-mutation'],
    mutationFn: (roleId: bigint) => dscvrIcApi.portal.deletePortalRole(roleId),
  });
};
